export const deleteCardQuery = /* GraphQL */ `
    mutation {
        deleteCard {
            status
            message
        }
    }
`

export interface DeleteCardOutput {
    deleteCard: {
        status: string
        message: string
    }
}
